import { FC } from 'react';
import { motion } from 'framer-motion';

import FlareTaglineLogo from '../../../assets/Flare_tagline_horizontal_dark_bg.png';

const AUREUS = {
  green: '#6FC2AE',
  blue: '#609EBD',
  navy: '#01263D'
};

const fadeInUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.65 } }
};

/**
 * Ecosystem strip — Flare as the chain Oxen Flow is built on.
 * Avoids implying a formal partnership beyond product integration.
 */
const BuiltOnFlareSection: FC = () => {
  return (
    <section className="py-16 md:py-20">
      <motion.div
        className="mx-auto max-w-3xl px-6 text-center"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeInUp}
      >
        <p
          className="text-xs uppercase tracking-[0.25em] mb-6 font-medium"
          style={{ color: AUREUS.blue }}
        >
          Built on
        </p>
        <a
          href="https://flare.network"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block group"
        >
          <div className="relative inline-block">
            <div
              className="absolute -inset-4 rounded-2xl blur opacity-20 group-hover:opacity-35 transition-opacity"
              style={{
                background: `linear-gradient(90deg, ${AUREUS.green}, ${AUREUS.blue})`
              }}
            />
            <img
              src={FlareTaglineLogo}
              alt="Flare Network"
              className="relative h-12 md:h-14 w-auto mx-auto"
              loading="lazy"
              decoding="async"
            />
          </div>
        </a>
        <p className="mt-6 text-base md:text-lg opacity-75 max-w-xl mx-auto leading-relaxed">
          Fast finality, low fees, and native bridges for XRP — the network
          layer Oxen Flow is designed around.
        </p>
      </motion.div>
    </section>
  );
};

export default BuiltOnFlareSection;
